/**
 * Local mirror of HubConnectionState from @microsoft/signalr.
 *
 * Keeping this as a local enum avoids taking a direct dependency on
 * @microsoft/signalr in consumers that only need the connection state values.
 * The string values are identical to the upstream enum so comparisons with
 * values emitted by SignalrService work transparently.
 */
export enum HubConnectionState {
  Connecting = 'Connecting',
  Connected = 'Connected',
  Disconnected = 'Disconnected',
  Reconnecting = 'Reconnecting',
}
